import { MutationTree } from 'vuex';

const mutations: MutationTree<Store.Video.State> = {
  add(state, payload: Services.Gallery.Response.Video) {
    state.data = payload;
  },
};

export { mutations };
